import React from 'react'
import { formatCurrency } from 'lib/currencies'
import { useTranslation } from 'lib/i18n'
import { RefinementListProvided } from 'react-instantsearch-core'
import { connectRefinementList } from 'react-instantsearch-dom'

import Checkbox from 'components/Filters/Checkbox'
import CheckboxList from 'components/Filters/CheckboxList'
import Hit from 'components/Filters/types/Hit'
import FilterTitle from 'components/UI/Filters/FilterTitle'
import FilterWrapper from 'components/UI/Filters/FilterWrapper'
import useMarket from 'hooks/useMarket'

const getFirstRangeValue = (label: string) => Number(label.match(/\d+/)[0])

const byPriceAsc = (a: Hit, b: Hit) =>
  getFirstRangeValue(a.label) - getFirstRangeValue(b.label)

const onlyWithHits = ({ count }: Hit) => count > 0

const CustomPriceBucketRefinementList = ({
  items,
  refine,
}: RefinementListProvided) => {
  const market = useMarket()
  const { t } = useTranslation()

  const ranges = items.filter(onlyWithHits)

  if (!ranges.length) {
    return null
  }

  const withCurrency = (value: string) =>
    formatCurrency({
      currency: market.defaultCurrency,
      valueInCent: Number(value),
    })

  const format = (item: Hit) => {
    const range = item.label.split('-').map(withCurrency)

    return {
      ...item,
      label: range.length === 1 ? `${range[0]} +` : range.join(' - '),
    }
  }

  return (
    <FilterWrapper>
      <FilterTitle title={t('filter.price.title', 'Price')} />
      <CheckboxList>
        {items
          .filter(onlyWithHits)
          .sort(byPriceAsc)
          .map(format)
          .map((item) => (
            <Checkbox key={item.label} item={item} refine={refine} />
          ))}
      </CheckboxList>
    </FilterWrapper>
  )
}

export default connectRefinementList(CustomPriceBucketRefinementList)
